/**
 * @file index.tsx
 *
 * @fileoverview Shows an empty box placeholder for the video gallery section of organizations.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import { OrganizationEmptyBoxPlaceholder } from '~/jobiqo/components/Organization/Widgets/OrganizationBoxPlaceholder';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { AddIcon } from '~/vcl/icons/Add';
import { VideoGalleryIcon } from '~/vcl/icons/VideoGallery';

interface OrganizationVideoGalleryWidgetEmptyProps {
  /**
   * The current resume.
   */
  organization: OrganizationProfile;
  /**
   * The current box id.
   */
  boxId: string;
}

export const OrganizationVideoGalleryWidgetEmpty = ({
  organization,
  boxId,
}: OrganizationVideoGalleryWidgetEmptyProps) => {
  const intl = useIntl();
  return (
    <Box>
      <OrganizationEmptyBoxPlaceholder
        organization={organization}
        field={boxId}
        text={intl.formatMessage({
          id: 'organization_video_gallery_empty_text',
          defaultMessage: `Enter your organization video gallery. Videos help applicant's engage and identity with the culture
          and identity of your brand and organization.`,
        })}
        buttonText={intl.formatMessage({
          id: 'organization_video_gallery_empty_enter',
          defaultMessage: `Create video gallery`,
        })}
        icon={<VideoGalleryIcon title="Video gallery" />}
        buttonIcon={<AddIcon title="video gallery" />}
      />
    </Box>
  );
};
